import { LinkField, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';

export type LinkItem = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    BaseLink: LinkField;
    BasePhoneNumber: {
      value: string;
    };
    UtilitySubLink: Array<SubLinkItem>;
    svg: {
      value: string;
    };
  };
};

export type InternalLink = {
  value: {
    href: string;
    text: string;
    anchor: string;
    linktype: 'internal';
    class: string;
    title: string;
    target: string;
    querystring: string;
    id: string;
  };
};

export type ExternalLink = {
  value: {
    href: string;
    text: string;
    linktype: 'external';
    url: string;
    anchor: string;
    target: string;
  };
};

export type GeneralLink = InternalLink | ExternalLink;

export type BackgroundColor = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    Key: {
      value: string;
    };
    Phrase: {
      value: string;
    };
  };
};

export type CardLink = {
  value: {
    href: string;
    text: string;
    linktype: 'external';
    url: string;
    anchor: string;
    target: string;
  };
};

export type CardImage = {
  value: {
    src: string;
    alt: string;
    width: string;
    height: string;
  };
};

export type CardImagePosition = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    name: {
      value: string;
    };
    heading: {
      value: string;
    };
  };
};

export type SubLinkItem = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    allowColumnFlow?: {
      value: boolean;
    };
    startInNewColumn?: {
      value: boolean;
    };
    listitemtype?: {
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        heading: {
          value: string;
        };
      };
    };
    lists?: Array<{
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        generalLink?: GeneralLink;
      };
    }>;
    link?: CardLink;
    image?: CardImage;
    heading?: {
      value: string;
    };
    imagePosition?: CardImagePosition;
    description?: {
      value: string;
    };
    generalLink?: LinkField;
  };
};

export type InternalLinksItem = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    columnNumber: {
      value: string;
    };
    maxColumnRows: {
      value: string;
    };
    BackgroundColor: BackgroundColor;
    BaseLink: LinkField;
    BasePhoneNumber: {
      value: string;
    };
    BaseSvg: {
      value: string;
    };
    SubLink: SubLinkItem[];
    svg: {
      value: string;
    };
  };
};

export type OSFHeaderProps = StyleguideComponentProps & {
  fields: {
    logo: ImageField;
    placeholder: {
      value: string;
    };
    svg: {
      value: string;
    };
    links: LinkItem[];
    internalLinks: InternalLinksItem[];
    homeUrl: LinkField;
  };
};
